import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { MapPin, Clock } from "lucide-react";

export default function Events() {
  const [events, setEvents] = useState([]);
  const { user } = useAuth();

  useEffect(() => {
    api.get("/events").then((r) => setEvents(r.data || [])).catch(() => {});
  }, []);

  const upcoming = events.filter((e) => !e.date || new Date(e.date) >= new Date(new Date().toDateString()));

  if (upcoming.length === 0) return null;

  return (
    <section id="events" data-testid="events-section" className="py-24 lg:py-32 bg-[#FAF9F6]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="mb-12 max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] text-[#5C6661] mb-4">Life together</div>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-[#1C201E] leading-tight">
            Upcoming Events
          </h2>
        </div>

        {upcoming.length === 0 ? (
          <div data-testid="no-events" className="p-12 rounded-2xl border border-dashed border-[#E5E0D8] text-center text-[#5C6661]">
            No events scheduled at this time. Check back soon.
          </div>
        ) : (
          <div className="space-y-3">
            {upcoming.map((e, i) => (
              <div key={e.id} data-testid={`event-card-${i}`} className="p-6 md:p-8 border border-[#E5E0D8] rounded-2xl grid md:grid-cols-12 gap-4 items-center bg-white/50">
                <div className="md:col-span-2">
                  <div className="text-3xl font-serif-display text-[#2C4C3B]">
                    {new Date(e.date).toLocaleDateString(undefined, { day: "numeric" })}
                  </div>
                  <div className="text-xs uppercase tracking-[0.2em] text-[#5C6661]">
                    {new Date(e.date).toLocaleDateString(undefined, { month: "short", year: "numeric" })}
                  </div>
                </div>
                <div className="md:col-span-7">
                  <h3 className="font-serif-display text-2xl text-[#1C201E]">{e.title}</h3>
                  {e.description && <p className="mt-1 text-sm text-[#5C6661]">{e.description}</p>}
                </div>
                <div className="md:col-span-3 text-sm text-[#5C6661] space-y-1">
                  {e.time && <div className="flex items-center gap-2"><Clock className="w-4 h-4 text-[#D4A373]" />{e.time}</div>}
                  {user && user.role !== "pending" && <a className="inline-block text-[#2C4C3B] underline py-2" href={`https://app.bbcbarani.org/feed?event_id=${encodeURIComponent(e.id)}`}>Share to BBC Connect News Feed</a>}
                  {e.location && <div className="flex items-center gap-2"><MapPin className="w-4 h-4 text-[#D4A373]" />{e.location}</div>}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
